<template>
    <svg v-if="props.isNavPrevious" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16 9C14.9 9 14 9.83747 14 10.8843L14 45.1157C14 46.1625 14.9 47 16 47C17.1 47 18 46.1625 18 45.1157L18 10.8843C18 9.83747 17.1 9 16 9Z"
            fill="white"
        />
        <path
            d="M40.0676 9C40.3575 9 40.5507 9.10437 40.8406 9.20874C41.5169 9.52186 42 10.2525 42 11.0874L42 44.9041C42 45.7391 41.5169 46.4697 40.8406 46.7828C40.0676 
                47.2003 39.2947 46.9915 38.715 46.3653L22.5797 29.457C22.1932 29.0395 22 28.5176 22 27.9958C22 27.4739 22.1932 26.8477 22.5797 26.5346L38.715 9.62624C39.1015 
                9.20875 39.5845 9 40.0676 9ZM38.1353 39.9986L38.1353 16.0973L26.7343 28.1001L38.1353 39.9986Z"
            fill="white"
        />
    </svg>

    <svg v-else width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.9324 47C15.6425 47 15.4493 46.8956 15.1594 46.7913C14.4831 46.4781 14 45.7475 14 44.9126L14 11.0959C14 10.2609 14.4831 9.53032 15.1594 9.2172C15.9324 
                8.79971 16.7053 9.00846 17.285 9.63469L33.4203 26.543C33.8068 26.9605 34 27.4824 34 28.0042C34 28.5261 33.8068 29.1523 33.4203 29.4654L17.285 46.3738C16.8985 
                46.7913 16.4155 47 15.9324 47ZM17.8647 16.0014L17.8647 39.9027L29.2657 27.8999L17.8647 16.0014Z"
            fill="white"
        />
        <path
            d="M40 47C41.1 47 42 46.1625 42 45.1157L42 10.8843C42 9.83747 41.1 9 40 9C38.9 9 38 9.83747 38 10.8843L38 45.1157C38 46.1625 38.9 47 40 47Z"
            fill="white"
        />
    </svg>
</template>

<script setup lang="ts">
    const props = defineProps({
        isNavPrevious: {
            type: Boolean,
            required: true
        }
    });
</script>
